import type { AlxPassMetrics } from './types'
import {
  parseFinishTime,
  parseHeatInput,
  parseLine424344,
  parseTravelSpeed
} from './lineParsers'

export function extractAlxDataFromText(text: string): AlxPassMetrics | null {
  const data: AlxPassMetrics = {
    voltageMax: null,
    voltageAvg: null,
    voltageMin: null,
    currentMax: null,
    currentAvg: null,
    currentMin: null,
    heatInputKJPerInch: null,
    travelSpeedInchPerMin: null,
    finishTime: null
  }

  for (const rawLine of text.split(/\r?\n/)) {
    const line = rawLine.trim()
    if (line.startsWith('42')) {
      const parsed = parseLine424344(line)
      if (parsed?.statType === 'MAX') {
        data.voltageMax = parsed.voltage
        data.currentMax = parsed.current
      }
    } else if (line.startsWith('43')) {
      const parsed = parseLine424344(line)
      if (parsed?.statType === 'AVG') {
        data.voltageAvg = parsed.voltage
        data.currentAvg = parsed.current
      }
    } else if (line.startsWith('44')) {
      const parsed = parseLine424344(line)
      if (parsed?.statType === 'MIN') {
        data.voltageMin = parsed.voltage
        data.currentMin = parsed.current
      }
    } else if (line.startsWith('83')) {
      const heat = parseHeatInput(line)
      if (heat !== null) data.heatInputKJPerInch = heat
    } else if (line.startsWith('50')) {
      const speed = parseTravelSpeed(line)
      if (speed !== null) data.travelSpeedInchPerMin = speed
    } else if (line.startsWith('51')) {
      const time = parseFinishTime(line)
      if (time) data.finishTime = time
    }
  }

  const hasData =
    data.voltageMax !== null ||
    data.voltageAvg !== null ||
    data.currentMax !== null ||
    data.heatInputKJPerInch !== null

  return hasData ? data : null
}
